import { createSlice } from '@reduxjs/toolkit';
import { SortDirection, TYPE_OF_ANT_DESIGN } from 'common/constant';
import showMessage from 'components/Message';
import i18n from 'i18n/i18n';

type CargoTraceSearchState = {
  showSearchModal: boolean;
  showSortModal: boolean;
  sortSelected: {
    name: string;
    value: string;
  } | null;
  sortDirection: string;
  filterSearchData: any;
  filterSearchTotal: number;
  filterContainerInfo: any;
  filterUserData: any;
  filterColumnItemData: any;
  loading: boolean;
  message: string;
};

const initialState: CargoTraceSearchState = {
  showSearchModal: true,
  showSortModal: false,
  loading: false,
  sortSelected: null,
  sortDirection: '',
  filterSearchData: [],
  filterContainerInfo: [],
  filterColumnItemData: [],
  filterUserData: [],
  filterSearchTotal: 0,
  message: '',
};

export const cargoTraceSearchSlice = createSlice({
  name: 'cargoTraceSearch',
  initialState,
  reducers: {
    toggleSearchModal: (state) => {
      if (!state.showSearchModal) {
        state.showSortModal = false;
      }
      state.showSearchModal = !state.showSearchModal;
    },
    toggleSortModal: (state) => {
      if (!state.showSortModal) {
        state.showSearchModal = false;
      }
      state.showSortModal = !state.showSortModal;
    },
    setSortSelected: (state, action) => {
      state.sortSelected = action.payload;
      if (action.payload) {
        state.sortDirection = SortDirection.ASC;
      }
      if (!state.filterSearchData.length) {
        state.showSortModal = false;
        state.showSearchModal = true;
      }
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },
    filterCargoTrace: (state, action) => {
      state.loading = true;
      if (!state.sortDirection) {
        state.sortDirection = SortDirection.ASC;
      }
    },
    filterCargoTraceSuccess: (state, action) => {
      if (!action.payload.data?.length) {
        showMessage(TYPE_OF_ANT_DESIGN.WARNING, i18n.t('message.common.0001'));
      } else {
        state.showSearchModal = false;
      }
      state.filterSearchData = action.payload.data || [];
      state.filterSearchTotal = action.payload.total;
      state.loading = false;
      state.showSortModal = false;
    },
    filterUserData: (state, action) => {
      state.loading = true;
    },
    filterContainerInfo: (state, action) => {
      state.loading = true;
    },
    filterCargoTraceFailure: (state) => {
      state.loading = false;
    },
    filterUserDataSuccess: (state, action) => {
      state.filterUserData = action.payload || [];
      state.loading = false;
    },
    filterContainerInfoSuccess: (state, action) => {
      if (action.payload?.length > 0) {
        state.filterContainerInfo = action.payload;
        state.message = '';
      }
      if (action.payload?.length === 0) {
        state.message = i18n.t('message.common.0001');
      }
      state.loading = false;
    },
    filterContainerInfoFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    filterColumnItem: (state) => {},
    filterColumnItemSuccess: (state, action) => {
      state.filterColumnItemData = action.payload || [];
    },
    clearData: (state) => {
      return {
        ...initialState,
      };
    },
    clearSearchData: (state) => {
      state.showSearchModal = true;
      state.showSortModal = false;
      state.sortSelected = null;
      state.sortDirection = '';
      state.filterSearchData = [];
      state.filterSearchTotal = 0;
    },
  },
});

export const {
  toggleSearchModal,
  toggleSortModal,
  setSortSelected,
  setSortDirection,
  filterCargoTrace,
  filterCargoTraceSuccess,
  filterContainerInfo,
  filterContainerInfoSuccess,
  filterContainerInfoFailure,
  filterCargoTraceFailure,
  setLoading,
  filterUserData,
  filterUserDataSuccess,
  filterColumnItem,
  filterColumnItemSuccess,
  clearData,
  clearSearchData,
} = cargoTraceSearchSlice.actions;

export default cargoTraceSearchSlice.reducer;
